import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnplottedXyicon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3 14V18L12 20M3 14L12 12L21 14M3 14L12 16M21 14V18L12 20M21 14L12 16M12 16V20",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8 8L11 8H12C13.1046 8 14 7.10457 14 6V2M14 2L16 4M14 2L12 4",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgUnplottedXyicon;
